import { TArrayAxiosResponse } from '@/common/types/response';

export type TProductItem = {
  id: number;
  code: string;
  name: string;
  level: number;
  isLeaf?: boolean;
  isOpen?: boolean;
  isFolder?: boolean;
};

export enum LocalContextMenuActions {
  SELECT_ALL_CHILDREN_BY_LEVEL = 'select-all-children-by-level',
  SELECT_ALL_CHILDREN = 'select-all-children',
  UNSELECT_ALL_CHILDREN = 'unselect-all-children',
}

export type TTreeSelectionProductsModalData = {
  items: TProductItem[];
  searchItems: TProductItem[];
  visibleItems: TProductItem[];
  preparedVisibleItems: TProductItem[];
  mapItems: Record<number, TProductItem & { childrenIds: number[] }>;
  request: {
    pageNumber: number;
    pageSize: number;
    term: string;
  };
  selection: (number | string)[];
  screenWidth: number;
  searchTimeout: number | null;
  searchWorker: Worker | null;
  isLoading: boolean;
  globalContextMenu: {
    isVisible: boolean;
    position: { right: number; top: number };
  };
  localContextMenu: {
    isVisible: boolean;
    position: { right: number; top: number };
    selectedItem: TProductItem | null;
  };
};

export type TProductsTreeFetcher = () => Promise<TArrayAxiosResponse<TProductItem>>;
